export default "__VITE_ASSET__ec05b7c3__"